/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required, @atlaskit/volt-strict-mode/no-re-exports, @atlaskit/editor/no-re-export -- VOLTC-139 tracks removal of these deprecated re-export shims. */
class UFOLogger {
	enabled = false;
	static UFOprefix = '[ufo🛸]';

	log(...args: Array<any>): void {
		// eslint-disable-next-line no-console
		this.enabled && console.log(UFOLogger.UFOprefix, ...args);
	}
	warn(...args: Array<any>): void {
		// eslint-disable-next-line no-console
		this.enabled && console.warn(UFOLogger.UFOprefix, ...args);
	}

	enable(): void {
		this.enabled = true;
	}

	disable(): void {
		this.enabled = false;
	}
}

export const ufologger: UFOLogger = new UFOLogger();

/**
 * @deprecated Use `import { ufolog } from '@atlassian/ufo-experimental'` instead.
 */

export { ufolog } from './ufolog';
/**
 * @deprecated Use `import { ufowarn } from '@atlassian/ufo-experimental'` instead.
 */
export { ufowarn } from './ufowarn';
